<section class="filters" [formGroup]="fieldForm">
  <div
    class="selectFilter"
    *ngIf="currentDataFields && currentDataFields.length > 0"
  >
    <div class="left">
      <mat-form-field appearance="fill" style="width: 95%">
        <mat-select
          class="filterSelect"
          formControlName="selectItem"
          placeholder="Choose Filter to add"
          floatPlaceholder="never"
          (selectionChange)="addFilter()"
        >
          <mat-option *ngFor="let item of currentDataFields" [value]="item.id">
            {{ item.name }}
          </mat-option>
          <mat-option value="-1" (click)="addDynamic()">
            Dynamic - Current Group
          </mat-option>
          <mat-option value="-2" (click)="addDynamicUser()">
            Dynamic - Current User
          </mat-option>
        </mat-select></mat-form-field
      >
    </div>
  </div>
  <span class="applied">APPLIED FILTERS </span>
  <span
    class="applied2"
    *ngIf="filterLogicMapping && filterLogicMapping.length > 0"
    >for reference</span
  >

  <div class="fieldArea" [formGroup]="fieldForm">
    <div class="error">{{ error }}</div>
    <div class="reportField-list">
      <ng-container
        *ngFor="let reportField of filterFields; let i = index"
        formArrayName="conditions"
      >
        <div class="reportField-box">
          <div
            class="canvasFields"
            id="filterRight-{{ i }}"
            [ngClass]="{ selected: selectedIndex == i }"
          >
            <div class="far-left">{{ i + 1 }}.</div>
            <div class="left">
              <app-datapoint-icons
                [type]="reportField.type || reportField.dataPoint.data.type"
              ></app-datapoint-icons>
            </div>
            <div
              class="right"
              matTooltip="{{
                reportField.name || reportField.dataPoint.data.name
              }}"
              matTooltipPosition="above"
            >
              <div
                class="title"
                (click)="
                  configureFilter(
                    $event,
                    i,
                    reportField.id || reportField.dataPoint.data.id,
                    reportField,
                    false
                  )
                "
              >
                {{ reportField.name || reportField.dataPoint.data.name }}
              </div>
              <div class="type"></div>
            </div>
            <div class="far-right">
              <fa-icon
                [icon]="faEdit"
                (click)="
                  configureFilter(
                    $event,
                    i,
                    reportField.id || reportField.dataPoint.data.id,
                    reportField,
                    false
                  )
                "
                matTooltip="Configure this filter"
                matTooltipPosition="above"
                *ngIf="reportField.id != -1"
              ></fa-icon>
              <fa-icon
                [icon]="faTrash"
                (click)="removeDataField($event, i)"
              ></fa-icon>
            </div>
          </div>
        </div>
        <ng-container
          *ngIf="
            !filterLogicMapping || filterLogicMapping.mappingList.length <= 0
          "
        >
          <div
            [formGroupName]="i"
            class="conditional"
            *ngIf="i + 1 < filterFields.length"
          >
            <span
              (click)="filterFields[i + 1].id != -1 && changeCondition(i)"
              matTooltip="click to toggle between and/or statements"
              ><input
                matInput
                formControlName="condition"
                name="condition"
                aria-label=""
                readonly="true"
            /></span>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            filterLogicMapping && filterLogicMapping.mappingList.length > 0
          "
        >
          <div class="line" *ngIf="i + 1 < filterFields.length"></div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="departmentScope">
        <div class="reportField-box">
          <div class="conditional" *ngIf="filterFields.length > 0">
            <span>and</span>
          </div>
          <div
            class="canvasFields"
            id="filterRight-{{ filterFields.length + 1 }}"
            [ngClass]="{ selected: selectedIndex == filterFields.length + 1 }"
          >
            <div class="far-left">{{ filterFields.length + 1 }}.</div>
            <div class="left">
              <app-datapoint-icons type="group"></app-datapoint-icons>
            </div>
            <div
              class="right"
              matTooltip="Dynamic - Current Group"
              matTooltipPosition="above"
            >
              <div class="title">Dynamic - Group</div>
              <div class="type"></div>
            </div>
            <div class="far-right">
              <fa-icon
                [icon]="faTrash"
                (click)="removeDynamic($event, filterFields.length + 1)"
              ></fa-icon>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="employeeScope">
        <div class="reportField-box">
          <div class="conditional" *ngIf="filterFields.length > 0">
            <span>and</span>
          </div>
          <div
            class="canvasFields"
            id="filterRight-{{ filterFields.length + 1 }}"
            [ngClass]="{ selected: selectedIndex == filterFields.length + 1 }"
          >
            <div class="far-left">{{ filterFields.length + 1 }}.</div>
            <div class="left">
              <app-datapoint-icons type="user"></app-datapoint-icons>
            </div>
            <div
              class="right"
              matTooltip="Dynamic - User"
              matTooltipPosition="above"
            >
              <div class="title">Dynamic - User</div>
              <div class="type"></div>
            </div>
            <div class="far-right">
              <fa-icon
                [icon]="faTrash"
                (click)="removeDynamicUser($event, filterFields.length + 1)"
              ></fa-icon>
            </div>
          </div>
        </div>
      </ng-container>

      <span
        class="logicMessage"
        *ngIf="filterLogicMapping && filterLogicMapping.mappingList.length > 0"
        >Advanced logic has previously been applied to the filters, you must
        click below to view the logic</span
      >
      <span
        (click)="openmappingList($event)"
        class="logicLink"
        *ngIf="filterFields && filterFields.length > 1 && enableBooleanLogic"
        >Advanced boolean logic</span
      >
    </div>
  </div>

  <mat-menu #itemMenu="matMenu" class="appliedMenu">
    <ng-template matMenuContent let-aliasMenuItems="element"
      ><div class="filterContent">
        Configure {{ aliasMenuItems }}
        <button mat-button class="button_small">Apply</button>
      </div></ng-template
    >
  </mat-menu>
</section>
